import * as Types from '../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type VerifyEmailMutationVariables = Types.Exact<{
  token: Types.Scalars['String']['input'];
}>;


export type VerifyEmailMutation = { __typename: 'Mutation', verifyEmail: { __typename: 'VerifyEmailResult', token: string, onboardingCompleted: boolean, user: { __typename: 'SignupUserInfo', uuid: string, email: string, firstName?: string | null, lastName?: string | null, isActive: boolean, isOnboardingCompleted: boolean, ssoProvider?: string | null, has3dExperience?: boolean | null, newsletterOptIn?: boolean | null, emailNotifications?: boolean | null }, organization: { __typename: 'SignupOrganizationInfo', uuid: string, name?: string | null, type?: Types.OrganizationType | null, stripeSubscriptionStatus?: string | null, trialEndsAt?: string | null }, membership: { __typename: 'SignupMembershipInfo', uuid: string, role: Types.MembershipRole } } };

export const VerifyEmailDocument = gql`
    mutation verifyEmail($token: String!) {
  verifyEmail(token: $token) {
    token
    user {
      uuid
      email
      firstName
      lastName
      isActive
      isOnboardingCompleted
      ssoProvider
      has3dExperience
      newsletterOptIn
      emailNotifications
    }
    organization {
      uuid
      name
      type
      stripeSubscriptionStatus
      trialEndsAt
    }
    membership {
      uuid
      role
    }
    onboardingCompleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class VerifyEmailGQL extends Apollo.Mutation<VerifyEmailMutation, VerifyEmailMutationVariables> {
    override document = VerifyEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }